import { Container, Box } from '@mui/material';

export default function Section({children, ...props}) {
  return (
    <Box {...props}>
      <Container maxWidth="md" sx={{paddingX: 3, paddingTop: 6, paddingBottom: 3}}>
        <Box sx={{minHeight: 'calc(100vh - 88px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          {children}
        </Box>
      </Container>
    </Box>
  );
}
